class UserPlan {

  constructor(currentUserBasePath, apiClient) {

    this.userBasePath = `${currentUserBasePath}/plan`;
    this.apiClient = apiClient;

  }

  async getActivePlanForUser() {

    const path = this.userBasePath;

    return this.apiClient.get(path, {}, {});

  }

  async exitSubscription() {

    const path = this.userBasePath;

    return this.apiClient.delete(path, {}, {});

  }

}

export default UserPlan;